
import Popup from 'vux/src/components/popup/index.vue'


export default {
name: 'hotel-count',
components: {
Popup,
},
props: {
result: {
type: Number,
default(){
return 0;
},
},
show: {
type: Boolean,
default(){
return false;
},
}
},
data(){
return {
isShow: false,
};
},
watch: {
show(cur){
this.isShow = cur;
},
},
methods: {
onHide(){
this.$emit('on-hide');
},

onShow(){
setTimeout(() => {
this.onHide();
}, 3000);
},
},
}



// WEBPACK FOOTER //
// ./src/views/hotel-list/components/HotelCount.vue